import { openAjaxCart, addCartEventHandlers } from '../utilities/add-to-cart';

function initScroll() {
  if (typeof $.fn.slick !== 'function') return;

  // $('.cart-holder .cart__body').height(function() {
  //   return $(window).height() - ($('.cart-holder .cart__header').outerHeight(true) + $('.cart-holder .cart__textarea').outerHeight(true) + $('.cart-holder .cart__subtotal').outerHeight(true) + $('.cart-holder .cart__cta').outerHeight(true) + 110);
  // });

  $('.cart-holder .cart__body')
    .height(function () {
      return (
        $(window).height() -
        ($('.cart-holder .cart__header').outerHeight(true) +
          $('.cart-holder .cart__textarea').outerHeight(true) +
          $('.cart-holder .cart__subtotal').outerHeight(true) +
          $('.cart-holder .cart__cta').outerHeight(true) +
          110)
      );
    })
    .niceScroll({
      cursorcolor: '#f1c148',
      cursorwidth: '11px',
      cursorborderradius: '10px',
      cursorborder: '1px solid #645531',
      background: '#bbb5b0',
    });
}

$(document).ready(function () {
  try {
    addCartEventHandlers();
  } catch (e) {
    Rollbar.error('cart js', e);
  }
});

$(window).on('resize', function () {
  try {
    initScroll();
  } catch (e) {
    Rollbar.error('cart js init scroll on resize', e);
  }
});
